import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function PwaBanner() {
  const [deferred, setDeferred] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem("agendik_pwa_dismissed") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (hidden || !deferred) return null;
  const dismiss = () => { localStorage.setItem("agendik_pwa_dismissed", "1"); setHidden(true); };
  const install = async () => {
    deferred.prompt(); await deferred.userChoice; dismiss();
  };

  return (
    <div data-testid="pwa-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 bg-white border border-blue-200 rounded-2xl shadow-lg p-4 flex items-start gap-3">
      <div className="w-10 h-10 rounded-xl bg-blue-600 flex-shrink-0 flex items-center justify-center">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M10 2h4v6h6v4h-6v10h-4V12H4V8h6V2z" fill="white"/></svg>
      </div>
      <div className="flex-1">
        <div className="text-sm font-semibold text-slate-900">Añade Agendik a tu pantalla de inicio</div>
        <div className="text-xs text-slate-500 mt-0.5">Acceso más rápido, sin App Store</div>
        <div className="flex gap-2 mt-3">
          <Button data-testid="pwa-install-btn" size="sm" onClick={install} className="bg-blue-600 hover:bg-blue-700 h-8">Añadir</Button>
          <Button data-testid="pwa-dismiss-btn" size="sm" variant="ghost" onClick={dismiss} className="h-8">Más tarde</Button>
        </div>
      </div>
      <button onClick={dismiss} className="text-slate-400 hover:text-slate-600"><X size={16}/></button>
    </div>
  );
}
